import { createContext } from "react";

const ReportDataContext = createContext({
  isLoading: false,
  patientName: "",
  patient: {},
  exam: {},
  reportData: {},
  refetchComment: () => {},
  getReportInfoData: () => {},
  fetchInitialReport: async (_) => {},
});

export { ReportDataContext };
